export const getDocsUrl = (ruleName: string): string =>
  `https://openapi-qraft.github.io/openapi-qraft/docs/eslint/${ruleName}`;
